export default __webpack_public_path__ + "25a4b8c36fa57bc73d32913218178ad9.svg";